module.exports = __webpack_public_path__ + "static/bridgeMusic-b0ba9cb5291887e95c5dd78e72b7740f.jpg";